import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom'
import { TirePage } from './Pages/TirePage'
import { catalogClient } from './services/grpc';
import { guidReq,guidRes } from './generated/catalog_pb'; 
import './styles/globals.css'
import Cookies from 'js-cookie';
import { AboutPage } from './Pages/About';
// Mock tire data
export default function App() {
  let isguid = Cookies.get('guid');
  if (typeof isguid != 'string') {
    const req= new guidReq();
    req.setIp(window.location.hostname);
    catalogClient.getGuid(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
        Cookies.set('guid', response.getGuid());
      }
    });
  }
  const guid = Cookies.get('guid');
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TirePage />} />
        <Route path="/preview_page.html" element={<TirePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/catalog" element={<Navigate to="/catalog/tire/all/all/all/all/all/all/all" replace />} />
        <Route 
          path="/catalog/tire/:brand/:season/:width/:profile/:diameter/:thorn/:puncture" 
          element={<TirePage />} 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}